import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Checkbox,
} from "@chakra-ui/react";
import { ChevronDownIcon, SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import SearchableSelect from "../../components/selectForm";
import iconEdit from "../../assets/images/product/edit.svg";
import icontrash from "../../assets/images/product/trash.svg";
import { AiOutlineMore } from "react-icons/ai";
import DeleteDialog from "../../components/dialog/delete";
import useDebounce from "../../hooks/useDebounce";
// import { useApartment } from "../../hooks/useApartments";
import { useCategories } from "../../categorys/apartments/index";
import toast from "react-hot-toast";
import FormNew from "./formApartments/fromNew";
import { apartmentCall } from "../../api/apartment";
import { useApartmentManager } from "../../hooks/useApartmentManagers";
import { priceFilter, StatusApartMent } from "../../utils/contants";
import SearchableSelectMuti from "../../components/selectForm/mutiSelect";
import PopupApartmentInfo from "../../components/popup/popupApartment";
import iconDetail from "../../assets/images/employee/detail.svg";
import { useSelector } from "react-redux";
import { employeeCall } from "../../api/employee";
const REACT_APP_ROUTE_RATE = process.env.REACT_APP_ROUTE_RATE || "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT"

const TableApartments = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenCloseAll,
    onOpen: onOpenCloseAll,
    onClose: onCloseCloseAll,
    onToggle: onToggleCloseAll,
  } = useDisclosure();
  const {
    isOpen: isOpenInfo,
    onOpen: onOpenInfo,
    onClose: onCloseInfo,
  } = useDisclosure();

  const user = useSelector((state) => state.auth.login?.currentUser);
  const [popupDelete, setPopupDelete] = useState(false);
  const [search, setSearch] = useState("");
  const [projectId, setProjectId] = useState(null);
  const [statusApartMent, setStatusApartMent] = useState(null);
  // const [apartmentTypeId, setApartmentTypeId] = useState(null);
  const [totalValue, setTotalValue] = useState(null);
  const [priceForCommission, setPriceForCommission] = useState(null);
  const [estimatedServiceFeePrice, setPriceAfterDiscount] = useState(null);
  const [saleOpeningEvent, setSaleOpeningEvents] = useState([]);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectDeleteAll, setSelectDeleteAll] = useState([]);
  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });
  const [getRoleUser, setGetRoleUser] = useState(false);

  const {
    apartmentData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useApartmentManager(
    debouncedSearchTerm,
    projectId,
    totalValue,
    priceForCommission,
    estimatedServiceFeePrice,
    saleOpeningEvent,
    statusApartMent,
    null,
    getRoleUser,
  );

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      setSelectedValues([]);
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      projectId,
      totalValue,
      priceForCommission,
      estimatedServiceFeePrice,
      saleOpeningEvent,
    });
  }, [
    paramData,
    debouncedSearchTerm,
    projectId,
    totalValue,
    priceForCommission,
    estimatedServiceFeePrice,
    saleOpeningEvent,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );
  const saleOpeningEvents = useMemo(
    () => formatEntries(constantData?.saleOpeningEvent),
    [constantData?.saleOpeningEvent]
  );
  const apartmentTypes = useMemo(
    () => formatEntries(constantData?.apartmentType),
    [constantData?.apartmentType]
  );

  const handlePageChange = (selectedPage) => {
    setPopupDelete(false);
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Mã căn hộ",
        key: "code",
      },
      {
        label: "Tên căn hộ",
        key: "name",
      },
      {
        label: "Dự án",
        key: "project",
      },
      // {
      //   label: "Phân khu",
      //   key: "division",
      // },
      // {
      //   label: "Hệ số K",
      //   key: "kRate",
      // },
      {
        label: "% thưởng nóng",
        key: "hotBonusPercent",
      },
      {
        label: "Giá trị",
        key: "totalValue",
      },
      {
        label: "Giá tính PDV",
        key: "priceForCommission",
      },
      {
        label: "Giá tính phí dịch vụ ước tính",
        key: "estimatedServiceFeePrice",
      },
      {
        label: "Đợt mở bán",
        key: "saleOpeningEvents",
      },
    ],
    data: apartmentData,
  };

  const filteredTableData = useMemo(
    () => ({
      ...tableData,
      data: Array.isArray(tableData?.data)
        ? tableData.data.filter((item) => item.isCanDelete === true)
        : [],
    }),
    [tableData]
  );

  const handlePopupDelete = (e) => {
    setPopupDelete(true);
    setDataEdit(e?.edit);
    onOpen();
  };

  const handlePopup = (e, type) => {
    setPopupDelete(false);
    if (type) {
      onOpen();
      setDataEdit(e?.edit);
    } else {
      onOpenInfo();
      setDataEdit(e?.detail);
    }
  };

  useEffect(() => {
    const isAllSelected =
      filteredTableData?.data?.length > 0 &&
      filteredTableData?.data?.every((item) =>
        selectedValues?.includes(item.id)
      );

    if (isAllSelected) {
      setSelectDeleteAll((prevDeleteAll = []) =>
        prevDeleteAll.includes(currentPage)
          ? prevDeleteAll
          : [...prevDeleteAll, currentPage]
      );
    }
  }, [selectedValues, filteredTableData, currentPage]);

  const handleCheckboxChange = (key) => {
    setSelectedValues((prev = []) => {
      if (prev.includes(key)) {
        setSelectDeleteAll((selectAll = []) => {
          return selectAll.includes(currentPage)
            ? selectAll.filter((item) => item !== currentPage)
            : selectAll;
        });
        return prev.filter((item) => item !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  const handleCheckboxDeleteAll = (current) => {
    setSelectDeleteAll((prev) => {
      if (prev.includes(current)) {
        if (
          Array.isArray(filteredTableData?.data) &&
          filteredTableData?.data.length > 0
        ) {
          setSelectedValues((select) =>
            select.filter(
              (id) => !filteredTableData?.data.some((item) => item.id === id)
            )
          );
        }
        return prev.filter((item) => item !== current);
      } else {
        if (
          Array.isArray(filteredTableData?.data) &&
          filteredTableData?.data.length > 0
        ) {
          setSelectedValues((select) => [
            ...new Set([
              ...select,
              ...filteredTableData?.data.map((item) => item.id),
            ]),
          ]);
        }
        return [...prev, current];
      }
    });
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa căn hộ ...");
    try {
      const { id, ...dataEdit } = data;
      let filteredData = Object.fromEntries(
        Object.entries(dataEdit).filter(
          ([_, value]) => value !== undefined && value !== null
        )
      );

      if (!filteredData.divisionId) {
        delete filteredData.divisionId;
      }
      if (!filteredData.propertyId) {
        delete filteredData.propertyId;
      }
      if (!filteredData.apartmentTypeId) {
        delete filteredData.apartmentTypeId;
      }
      if (!filteredData.directionId) {
        delete filteredData.directionId;
      }
      if (!filteredData.area) {
        filteredData.area = 0;
      }
      if (!filteredData.builtUpArea) {
        filteredData.builtUpArea = 0;
      }
      if (!filteredData.width) {
        filteredData.width = 0;
      }
      if (!filteredData.length) {
        filteredData.length = 0;
      }
      if (!filteredData.numberOfBedrooms) {
        filteredData.numberOfBedrooms = 0;
      }
      if (!filteredData.numberOfToilets) {
        filteredData.numberOfToilets = 0;
      }
      if (!filteredData.areaOfWater) {
        filteredData.areaOfWater = 0;
      }
      if (!filteredData.grossFloorArea) {
        filteredData.grossFloorArea = 0;
      }
      // if (!filteredData.kRate) {
      //   filteredData.kRate = 0;
      // }
      if (!filteredData.hotBonusPercent) {
        filteredData.hotBonusPercent = 0;
      }

      await apartmentCall.update(id, filteredData);

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onDeleteAll = async () => {
    onOpenCloseAll();
  };

  const deleteAll = async () => {
    if (Array.isArray(selectedValues) && selectedValues.length > 0) {
      const toastEdit = toast.loading("Đang xóa dữ liệu ...");
      try {
        await apartmentCall.deleteMany({ data: selectedValues });
        await refetch();
        setDataEdit(null);
        onCloseCloseAll();
        onToggleCloseAll();
        toast.success("Xóa thành công");
        setSelectedValues([]);
        setSelectDeleteAll([]);
      } catch (error) {
        console.error("Error:", error);
        toast.error("Có lỗi xảy ra khi xóa");
      }
      toast.dismiss(toastEdit);
    } else {
      toast.error("Vui lòng chọn dữ liệu trước khi xóa");
    }
  };

  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataEdit;
      await apartmentCall.delete(id);
      await refetch();
      setDataEdit(null);
      onClose();
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastEdit);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhập mã, tên căn hộ ..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <Menu>
                  <MenuButton
                    _active={{
                      border: "1px solid var(--color-option-employee-hover)",
                    }}
                    _hover={{
                      boxShadow: "none",
                    }}
                    h={"44px"}
                    as={Button}
                    rightIcon={<ChevronDownIcon color={"#000"} />}
                    w="200px"
                    backgroundColor="#FFF"
                    border={"1px solid var(--Line)"}
                  >
                    <Text
                      textAlign={"start"}
                      color={"#000"}
                      fontSize={"14px"}
                      fontWeight={500}
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      Chọn hành động
                    </Text>
                  </MenuButton>
                  <MenuList
                    fontSize={{ base: "14px" }}
                    fontWeight={500}
                    lineHeight={"140%"}
                    color={"var(--color-info-employee)"}
                  >
                    <MenuItem gap={"16px"} onClick={onDeleteAll}>
                      <Image src={icontrash} /> Xóa tất cả
                    </MenuItem>
                  </MenuList>
                </Menu>
                <SearchableSelect
                  isShowSearch={true}
                  options={projects}
                  initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  setValue={setProjectId}
                  minW={"249px"}
                />
                {/* <SearchableSelect
                  isShowSearch={true}
                  options={apartmentTypes}
                  initialSelectedOption={{ key: 0, value: "Chọn loại hình" }}
                  setValue={setApartmentTypeId}
                /> */}

                <SearchableSelect
                  isShowSearch={true}
                  options={priceFilter}
                  initialSelectedOption={{
                    key: null,
                    value: "Lọc giá trị căn hộ",
                  }}
                  setValue={setTotalValue}
                  minW={"249px"}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={priceFilter}
                  initialSelectedOption={{
                    key: null,
                    value: "Lọc giá tính phí dịch vụ",
                  }}
                  setValue={setPriceForCommission}
                  minW={"249px"}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={priceFilter}
                  initialSelectedOption={{
                    key: null,
                    value: "Lọc giá sau chiết khấu",
                  }}
                  setValue={setPriceAfterDiscount}
                  minW={"249px"}
                />
                <SearchableSelectMuti
                  isShowSearch={true}
                  options={saleOpeningEvents}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn đợt mở bán",
                  }}
                  setValue={setSaleOpeningEvents}
                  minW={"249px"}
                  placeholder={"Chọn đợt mở bán"}
                />

                <SearchableSelect
                  isShowSearch={true}
                  options={StatusApartMent}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn trạng thái căn hộ",
                  }}
                  setValue={setStatusApartMent}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      <Td
                        p={"16px 16px 8px 16px"}
                        border={"none"}
                        color={"#51607B"}
                        fontSize={{ base: "14px" }}
                        w={"auto"}
                      >
                        <Checkbox
                          size={"lg"}
                          gap={"24px"}
                          fontSize={"14px"}
                          lineHeight={"17px"}
                          fontWeight={"500"}
                          w={"100%"}
                          borderRadius={"8px"}
                          onChange={() => handleCheckboxDeleteAll(currentPage)}
                          isChecked={selectDeleteAll?.includes(currentPage)}
                        >
                          {/* {e.value} */}
                        </Checkbox>
                      </Td>
                      {tableData.headers.map((e, index) => {
                        if (
                          !getRoleUser &&
                          [
                            "commissionFromInvestor",
                            "commissionToSales",
                            "commissionFromPartner",
                          ].includes(e.key)
                        ) {
                          return null; 
                        }
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "start";
                        } else if (
                          e.key === "code" ||
                          e.key === "name" ||
                          e.key === "area" ||
                          e.key === "areaOfWater" ||
                          e.key === "builtUpArea" ||
                          e.key === "grossFloorArea" ||
                          e.key === "width" ||
                          e.key === "length"
                        ) {
                          width = "5%";
                          textAlign = "start";
                        } else if (
                          e.key === "numberOfBedrooms" ||
                          e.key === "numberOfToilets"
                        ) {
                          width = "5%";
                          textAlign = "center";
                        } else if (e.key === "project") {
                          width = "25%";
                          textAlign = "end";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        delete items.isCanDelete;
                        const keyValues = Object.keys(items);
                        if (!getRoleUser) {
                          delete items.commissionFromPartner;
                          delete items.commissionToSales;
                          delete items.commissionFromInvestor;
                        }
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td
                              p={"16px 16px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Checkbox
                                size={"lg"}
                                gap={"24px"}
                                fontSize={"14px"}
                                lineHeight={"17px"}
                                fontWeight={"500"}
                                w={"100%"}
                                borderRadius={"8px"}
                                onChange={() => handleCheckboxChange(e.id)}
                                isChecked={selectedValues.includes(e.id)}
                                disabled={!e?.isCanDelete}
                              >
                                {/* {e.value} */}
                              </Checkbox>
                            </Td>
                            <Td
                              p={"16px 16px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(e, true)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(e, false)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  {e?.isCanDelete ? (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() => handlePopupDelete(e)}
                                    >
                                      <Image src={icontrash} /> Xóa SP căn hộ
                                    </MenuItem>
                                  ) : (
                                    ""
                                  )}
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              {rowIndex + 1}
                            </Td>

                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "code" ||
                                keyvalue === "name" ||
                                keyvalue === "area" ||
                                keyvalue === "areaOfWater" ||
                                keyvalue === "builtUpArea" ||
                                keyvalue === "grossFloorArea" ||
                                keyvalue === "width" ||
                                keyvalue === "length"
                              ) {
                                width = "5%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "numberOfBedrooms" ||
                                keyvalue === "numberOfToilets"
                              ) {
                                width = "5%";
                                textAlign = "center";
                              } else if (keyvalue === "project") {
                                width = "40%";
                                textAlign = "end";
                                whiteSpace = "normal";
                                widthText = "487px";
                              } else {
                                width = "10%";
                                textAlign = "end";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"#293755"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {!popupDelete ? (
        <FormNew
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <DeleteDialog
          isOpen={isOpen}
          onClose={onClose}
          title="Xóa sản phẩm và căn hộ"
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa sản phẩm và căn hộ{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataEdit?.name}
              </Text>{" "}
              này không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}
      <DeleteDialog
        isOpen={isOpenCloseAll}
        onClose={onCloseCloseAll}
        title="Xóa sản phẩm và căn hộ"
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn xóa các sản phẩm và căn hộ có mã{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {tableData?.data
                ?.filter((item) => selectedValues.includes(item.id))
                ?.map((item) => item.code)
                ?.join(", ")}
            </Text>{" "}
            này không?"
          </Flex>
        }
        action={() => deleteAll()}
      />
      <PopupApartmentInfo
        isOpen={isOpenInfo}
        onClose={onCloseInfo}
        defaultValue={dataEdit || []}
      />
    </>
  );
};

export default TableApartments;
